import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, fmtDateTime } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export const NotificationBell = () => {
  const { t } = useLang();
  const loc = useLocation();
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, [loc.pathname]);

  const unread = items.filter((n) => !n.read).length;
  const onOpen = (o) => {
    if (o && unread) api.post("/notifications/read-all").then(load);
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-bell-btn" className="relative p-2 rounded-full hover:bg-slate-100 transition-colors" aria-label={t("notifications")}>
          <Bell size={20} />
          {unread > 0 && <span data-testid="notifications-unread-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-rose-600 text-white text-[10px] font-bold grid place-items-center px-1">{unread >= 50 ? "50+" : unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-panel">
        <div className="px-4 py-3 border-b font-semibold">{t("notifications")}</div>
        <div className="max-h-96 overflow-y-auto divide-y">
          {items.length === 0 && <p className="p-4 text-sm text-slate-500">No notifications yet.</p>}
          {items.map((n) => (
            <div key={n.id} className={`p-4 text-sm ${n.read ? "" : "bg-emerald-50/60"}`} data-testid="notification-item">
              <p className="font-semibold text-slate-900">{n.title}</p>
              <p className="text-slate-600 mt-0.5">{n.body}</p>
              <div className="flex justify-between mt-1 text-xs text-slate-400">
                <span>{fmtDateTime(n.created_at)}</span>
                {n.link && <Link to={n.link} className="text-[#0D5C46] font-semibold">Open</Link>}
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
